export default __webpack_public_path__ + "static/media/grafema_ummi_10.479a40c3.jpg";